/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import mbpUtil from 'mbp-api-util';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
    node, bool, object,
} from 'prop-types';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import withAsyncScript from '../../../../../../lib/scriptLoader';

const SMART_GIFT_SCRIPT_SRC = mbpUtil?.getEnv('APP_SG_BASKET_SCRIPT') || 'https://cdn2.smartgiftit.com/scripts/widgets/uat/gift-basket.js';

const SmartGiftWrapper = ({ children, isScriptLoadSucceed, brand = '1800flowers' }) => {
    if (!isScriptLoadSucceed) return null;
    if (typeof window !== 'undefined' && typeof window.SmartGiftWidget !== 'undefined') {
        // Mount the widget
        if (!document.querySelector('[src^="https://cdn2.smartgiftit.com/scripts/widgets/"]').length) window.SmartGiftWidget.mount(brand.domain);
    }
    return <>{children}</>;
};

SmartGiftWrapper.propTypes = {
    isScriptLoadSucceed: bool,
    children: node,
    brand: object.isRequired,
};

SmartGiftWrapper.defaultProps = {
    isScriptLoadSucceed: false,
    children: null,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});
const enhance = compose(
    connect(mapStateToProps),
    withAsyncScript(SMART_GIFT_SCRIPT_SRC),
);
export default enhance(SmartGiftWrapper);
